import type { Activity } from '../types';
import { activityTypes } from 'bundles/apex/activities/type/config';

export const activityHeaderText = (activity: Activity | null) => {
  if (!activity) {
    return '';
  }

  let header = activity.creator.name;
  if (activity.isEmailThread) {
    if (activity.sentByUser) {
      header = `${header} sent out an email`;
    } else {
      header = `${header} got a reply in a thread`;
    }
  } else {
    header = `${header} ${activityTypes[activity.activityType].phrase}`;
  }

  return header;
};
